import { AfterDeath } from '@/types/schema';

export interface ParsedNodeId {
  afterDeath: AfterDeath;
  entityId: string;
}

/**
 * Parses an estate waterfall node ID into its component parts.
 * Node IDs have the format: `{AfterDeath}:{entityId}`
 * e.g., "FIRST_DEATH:abc-123" -> { afterDeath: "FIRST_DEATH", entityId: "abc-123" }
 */
export function parseNodeId(nodeId: string): ParsedNodeId {
  const [afterDeath, ...idParts] = nodeId.split(':');
  return {
    afterDeath: afterDeath as AfterDeath,
    entityId: idParts.join(':'),
  };
}
